import { render, staticRenderFns } from "./ClientDiscounts.vue?vue&type=template&id=04c63186"
import script from "./ClientDiscounts.vue?vue&type=script&lang=js"
export * from "./ClientDiscounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports